import { render } from "./mvt-autocompletetag.vue?vue&type=template&id=dfc918a2"
import script from "./mvt-autocompletetag.js?vue&type=script&lang=js"
export * from "./mvt-autocompletetag.js?vue&type=script&lang=js"

import "./mvt-autocompletetag.vue?vue&type=style&index=0&id=dfc918a2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__